import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { InfoEntrega } from "./model";
import { obtenerInfoEntrega } from "./logic";
import { FirmaComponent } from "./finalizar/firma"

export interface Props {
    state: models.ViajeAppIniciado;
    claveEntrega: string;
}

class InfoEntregaCompSimple extends React.PureComponent<{ value: InfoEntrega }> {
    render() {
        const x = this.props.value;
        const textoAcuses = 
        x.AcusesEntrega.length > 0 ?
            x.AcusesEntrega.map(x => `${x.folio} (${x.tipoAcuse == models.TipoAcuse.Interno ? "Interno" :( "Externo, " +  x.requerimientoAcuse ) })`).join(", ") :
            "(ninguno)";

        return (
            <div>
                <kea.Panel title="Información" style="primary">
                    <h4>
                        Status:{" "}
                        <b>
                            {
                                x.Finalizado ? "Entrega finalizada" :
                                    x.GuiasExcluidas ? "Faltan algunas guias" : "Listo para finalizar"
                            }
                        </b>
                        <br/>
                        Acuses:{" "}<b>{textoAcuses}</b>
                    </h4>
                    <hr />
                    <label>Cliente:</label>{" "}{x.NombreCliente}<br />
                    <label>Dirección:</label>{" "}{x.NombreDestino}<br />
                    <hr />
                    <label>Total de guias:</label>{" "}{x.CantGuias}<br />
                    <label>Guias entregadas:</label>{" "}{x.GuiasEntregadas}<br />
                    <label>Guias rechazadas:</label>{" "}{x.GuiasRechazadas}<br />
                    <label>Guias no procesadas:</label>{" "}{x.GuiasExcluidas}<br />

                    {
                        x.Finalizado && 
                        <FirmaComponent value={x.Firma} />
                    }
                </kea.Panel>
            </div>
        );
    }
}

/**Muestra la cabecera de la entrega */
export class InfoEntregaComp extends React.PureComponent<Props> {
    state = (props: Props) => props.state;
    claveEntrega = (props: Props) => props.claveEntrega;
    info = createSelectorRx(this.state, this.claveEntrega, (state, clave) => obtenerInfoEntrega(state, clave));
    render() {
        const info = this.info(this.props);
        return <InfoEntregaCompSimple value={info} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/info.tsx